module.exports = __webpack_public_path__ + "img/directory-promotion-banner.3394fb5.svg";